var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 0H0V125H125V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 8.33337H8.33337V13.4921H13.4921V8.33337Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 13.4921H8.33337V18.6508H13.4921V13.4921Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 18.6509H8.33337V23.8096H13.4921V18.6509Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 23.8096H8.33337V28.9683H13.4921V23.8096Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 28.9683H8.33337V34.127H13.4921V28.9683Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 34.127H8.33337V39.2857H13.4921V34.127Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 39.2858H8.33337V44.4445H13.4921V39.2858Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 49.6031H8.33337V54.7619H13.4921V49.6031Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 54.762H8.33337V59.9207H13.4921V54.762Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 59.9207H8.33337V65.0794H13.4921V59.9207Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 65.0795H8.33337V70.2382H13.4921V65.0795Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 80.5555H8.33337V85.7143H13.4921V80.5555Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 85.7142H8.33337V90.873H13.4921V85.7142Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 90.8729H8.33337V96.0317H13.4921V90.8729Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 96.0317H8.33337V101.19H13.4921V96.0317Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 101.191H8.33337V106.349H13.4921V101.191Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 106.349H8.33337V111.508H13.4921V106.349Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4921 111.508H8.33337V116.667H13.4921V111.508Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6508 8.33337H13.4921V13.4921H18.6508V8.33337Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6508 39.2858H13.4921V44.4445H18.6508V39.2858Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6508 49.6031H13.4921V54.7619H18.6508V49.6031Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6508 80.5555H13.4921V85.7143H18.6508V80.5555Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6508 111.508H13.4921V116.667H18.6508V111.508Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 8.33337H18.6509V13.4921H23.8096V8.33337Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 18.6509H18.6509V23.8096H23.8096V18.6509Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 23.8096H18.6509V28.9683H23.8096V23.8096Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 28.9683H18.6509V34.127H23.8096V28.9683Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 39.2858H18.6509V44.4445H23.8096V39.2858Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 49.6031H18.6509V54.7619H23.8096V49.6031Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 65.0795H18.6509V70.2382H23.8096V65.0795Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 80.5555H18.6509V85.7143H23.8096V80.5555Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 90.8729H18.6509V96.0317H23.8096V90.8729Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 96.0317H18.6509V101.19H23.8096V96.0317Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 101.191H18.6509V106.349H23.8096V101.191Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8096 111.508H18.6509V116.667H23.8096V111.508Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 8.33337H23.8096V13.4921H28.9683V8.33337Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 18.6509H23.8096V23.8096H28.9683V18.6509Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 23.8096H23.8096V28.9683H28.9683V23.8096Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 28.9683H23.8096V34.127H28.9683V28.9683Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 39.2858H23.8096V44.4445H28.9683V39.2858Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 49.6031H23.8096V54.7619H28.9683V49.6031Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 65.0795H23.8096V70.2382H28.9683V65.0795Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 80.5555H23.8096V85.7143H28.9683V80.5555Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 90.8729H23.8096V96.0317H28.9683V90.8729Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 96.0317H23.8096V101.19H28.9683V96.0317Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 101.191H23.8096V106.349H28.9683V101.191Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9683 111.508H23.8096V116.667H28.9683V111.508Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1271 8.33337H28.9684V13.4921H34.1271V8.33337Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 18.6509H28.9685V23.8096H34.1272V18.6509Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 23.8096H28.9685V28.9683H34.1272V23.8096Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 28.9683H28.9685V34.127H34.1272V28.9683Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 39.2858H28.9685V44.4445H34.1272V39.2858Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 49.6031H28.9685V54.7619H34.1272V49.6031Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 59.9207H28.9685V65.0794H34.1272V59.9207Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 65.0795H28.9685V70.2382H34.1272V65.0795Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 70.2382H28.9685V75.3969H34.1272V70.2382Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 80.5555H28.9685V85.7143H34.1272V80.5555Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 90.8729H28.9685V96.0317H34.1272V90.8729Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 96.0317H28.9685V101.19H34.1272V96.0317Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 101.191H28.9685V106.349H34.1272V101.191Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1272 111.508H28.9685V116.667H34.1272V111.508Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2857 8.33337H34.127V13.4921H39.2857V8.33337Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2858 39.2858H34.1271V44.4445H39.2858V39.2858Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2858 65.0795H34.1271V70.2382H39.2858V65.0795Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2858 80.5555H34.1271V85.7143H39.2858V80.5555Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2858 111.508H34.1271V116.667H39.2858V111.508Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4445 8.33337H39.2858V13.4921H44.4445V8.33337Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 13.4921H39.2859V18.6508H44.4446V13.4921Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 18.6509H39.2859V23.8096H44.4446V18.6509Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 23.8096H39.2859V28.9683H44.4446V23.8096Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 28.9683H39.2859V34.127H44.4446V28.9683Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 34.127H39.2859V39.2857H44.4446V34.127Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 39.2858H39.2859V44.4445H44.4446V39.2858Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 49.6031H39.2859V54.7619H44.4446V49.6031Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 59.9207H39.2859V65.0794H44.4446V59.9207Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 70.2382H39.2859V75.3969H44.4446V70.2382Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 80.5555H39.2859V85.7143H44.4446V80.5555Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 85.7142H39.2859V90.873H44.4446V85.7142Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 90.8729H39.2859V96.0317H44.4446V90.8729Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 96.0317H39.2859V101.19H44.4446V96.0317Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 101.191H39.2859V106.349H44.4446V101.191Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 106.349H39.2859V111.508H44.4446V106.349Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4446 111.508H39.2859V116.667H44.4446V111.508Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6033 49.6031H44.4446V54.7619H49.6033V49.6031Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6033 54.762H44.4446V59.9207H49.6033V54.762Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6033 59.9207H44.4446V65.0794H49.6033V59.9207Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6033 70.2382H44.4446V75.3969H49.6033V70.2382Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 13.4921H49.6033V18.6508H54.762V13.4921Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 23.8096H49.6033V28.9683H54.762V23.8096Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 34.127H49.6033V39.2857H54.762V34.127Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 39.2858H49.6033V44.4445H54.762V39.2858Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 49.6031H49.6033V54.7619H54.762V49.6031Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 59.9207H49.6033V65.0794H54.762V59.9207Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 75.397H49.6033V80.5557H54.762V75.397Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 80.5555H49.6033V85.7143H54.762V80.5555Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 90.8729H49.6033V96.0317H54.762V90.8729Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 96.0317H49.6033V101.19H54.762V96.0317Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 101.191H49.6033V106.349H54.762V101.191Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 106.349H49.6033V111.508H54.762V106.349Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M54.762 111.508H49.6033V116.667H54.762V111.508Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9207 13.4921H54.762V18.6508H59.9207V13.4921Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9207 23.8096H54.762V28.9683H59.9207V23.8096Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9207 28.9683H54.762V34.127H59.9207V28.9683Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9207 44.4445H54.762V49.6032H59.9207V44.4445Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9207 54.762H54.762V59.9207H59.9207V54.762Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9207 65.0795H54.762V70.2382H59.9207V65.0795Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9207 70.2382H54.762V75.3969H59.9207V70.2382Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9207 90.8729H54.762V96.0317H59.9207V90.8729Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9207 111.508H54.762V116.667H59.9207V111.508Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0795 8.33337H59.9208V13.4921H65.0795V8.33337Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0795 13.4921H59.9208V18.6508H65.0795V13.4921Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0795 18.6509H59.9208V23.8096H65.0795V18.6509Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0795 39.2858H59.9208V44.4445H65.0795V39.2858Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0795 59.9207H59.9208V65.0794H65.0795V59.9207Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0795 80.5555H59.9208V85.7143H65.0795V80.5555Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0795 85.7142H59.9208V90.873H65.0795V85.7142Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0795 101.191H59.9208V106.349H65.0795V101.191Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 8.33337H65.0796V13.4921H70.2383V8.33337Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 18.6509H65.0796V23.8096H70.2383V18.6509Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 34.127H65.0796V39.2857H70.2383V34.127Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 49.6031H65.0796V54.7619H70.2383V49.6031Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 54.762H65.0796V59.9207H70.2383V54.762Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 65.0795H65.0796V70.2382H70.2383V65.0795Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 80.5555H65.0796V85.7143H70.2383V80.5555Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 90.8729H65.0796V96.0317H70.2383V90.8729Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 96.0317H65.0796V101.19H70.2383V96.0317Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2383 106.349H65.0796V111.508H70.2383V106.349Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 8.33337H70.2383V13.4921H75.397V8.33337Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 13.4921H70.2383V18.6508H75.397V13.4921Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 18.6509H70.2383V23.8096H75.397V18.6509Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 23.8096H70.2383V28.9683H75.397V23.8096Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 28.9683H70.2383V34.127H75.397V28.9683Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 39.2858H70.2383V44.4445H75.397V39.2858Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 54.762H70.2383V59.9207H75.397V54.762Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 59.9207H70.2383V65.0794H75.397V59.9207Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 65.0795H70.2383V70.2382H75.397V65.0795Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 70.2382H70.2383V75.3969H75.397V70.2382Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 75.397H70.2383V80.5557H75.397V75.397Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 96.0317H70.2383V101.19H75.397V96.0317Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 101.191H70.2383V106.349H75.397V101.191Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 106.349H70.2383V111.508H75.397V106.349Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M75.397 111.508H70.2383V116.667H75.397V111.508Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5556 49.6031H75.3969V54.7619H80.5556V49.6031Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5556 54.762H75.3969V59.9207H80.5556V54.762Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5556 65.0795H75.3969V70.2382H80.5556V65.0795Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5556 80.5555H75.3969V85.7143H80.5556V80.5555Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5556 90.8729H75.3969V96.0317H80.5556V90.8729Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5556 96.0317H75.3969V101.19H80.5556V96.0317Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5556 106.349H75.3969V111.508H80.5556V106.349Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 8.33337H80.5555V13.4921H85.7143V8.33337Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 13.4921H80.5555V18.6508H85.7143V13.4921Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 18.6509H80.5555V23.8096H85.7143V18.6509Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 23.8096H80.5555V28.9683H85.7143V23.8096Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 28.9683H80.5555V34.127H85.7143V28.9683Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 34.127H80.5555V39.2857H85.7143V34.127Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 39.2858H80.5555V44.4445H85.7143V39.2858Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 54.762H80.5555V59.9207H85.7143V54.762Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 59.9207H80.5555V65.0794H85.7143V59.9207Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 65.0795H80.5555V70.2382H85.7143V65.0795Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 96.0317H80.5555V101.19H85.7143V96.0317Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 101.191H80.5555V106.349H85.7143V101.191Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 106.349H80.5555V111.508H85.7143V106.349Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 8.33337H85.7142V13.4921H90.873V8.33337Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 39.2858H85.7142V44.4445H90.873V39.2858Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 49.6031H85.7142V54.7619H90.873V49.6031Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 59.9207H85.7142V65.0794H90.873V59.9207Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 70.2382H85.7142V75.3969H90.873V70.2382Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 75.397H85.7142V80.5557H90.873V75.397Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 85.7142H85.7142V90.873H90.873V85.7142Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 96.0317H85.7142V101.19H90.873V96.0317Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 101.191H85.7142V106.349H90.873V101.191Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 106.349H85.7142V111.508H90.873V106.349Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M90.873 111.508H85.7142V116.667H90.873V111.508Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0317 8.33337H90.8729V13.4921H96.0317V8.33337Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0317 18.6509H90.8729V23.8096H96.0317V18.6509Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0317 23.8096H90.8729V28.9683H96.0317V23.8096Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0317 28.9683H90.8729V34.127H96.0317V28.9683Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0317 39.2858H90.8729V44.4445H96.0317V39.2858Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0317 80.5555H90.8729V85.7143H96.0317V80.5555Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0317 85.7142H90.8729V90.873H96.0317V85.7142Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0317 90.8729H90.8729V96.0317H96.0317V90.8729Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 8.33337H96.0319V13.4921H101.191V8.33337Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 18.6509H96.0319V23.8096H101.191V18.6509Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 23.8096H96.0319V28.9683H101.191V23.8096Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 28.9683H96.0319V34.127H101.191V28.9683Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 39.2858H96.0319V44.4445H101.191V39.2858Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 49.6031H96.0319V54.7619H101.191V49.6031Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 54.762H96.0319V59.9207H101.191V54.762Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 65.0795H96.0319V70.2382H101.191V65.0795Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 80.5555H96.0319V85.7143H101.191V80.5555Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 85.7142H96.0319V90.873H101.191V85.7142Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 96.0317H96.0319V101.19H101.191V96.0317Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 101.191H96.0319V106.349H101.191V101.191Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 106.349H96.0319V111.508H101.191V106.349Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 111.508H96.0319V116.667H101.191V111.508Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 8.33337H101.191V13.4921H106.349V8.33337Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 18.6509H101.191V23.8096H106.349V18.6509Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 23.8096H101.191V28.9683H106.349V23.8096Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 28.9683H101.191V34.127H106.349V28.9683Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 39.2858H101.191V44.4445H106.349V39.2858Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 54.762H101.191V59.9207H106.349V54.762Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 59.9207H101.191V65.0794H106.349V59.9207Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 65.0795H101.191V70.2382H106.349V65.0795Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 75.397H101.191V80.5557H106.349V75.397Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 80.5555H101.191V85.7143H106.349V80.5555Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 85.7142H101.191V90.873H106.349V85.7142Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 101.191H101.191V106.349H106.349V101.191Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M106.349 106.349H101.191V111.508H106.349V106.349Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 8.33337H106.349V13.4921H111.508V8.33337Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 39.2858H106.349V44.4445H111.508V39.2858Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 49.6031H106.349V54.7619H111.508V49.6031Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 54.762H106.349V59.9207H111.508V54.762Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 59.9207H106.349V65.0794H111.508V59.9207Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 70.2382H106.349V75.3969H111.508V70.2382Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 75.397H106.349V80.5557H111.508V75.397Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 85.7142H106.349V90.873H111.508V85.7142Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 90.8729H106.349V96.0317H111.508V90.8729Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M111.508 111.508H106.349V116.667H111.508V111.508Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 8.33337H111.508V13.4921H116.667V8.33337Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 13.4921H111.508V18.6508H116.667V13.4921Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 18.6509H111.508V23.8096H116.667V18.6509Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 23.8096H111.508V28.9683H116.667V23.8096Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 28.9683H111.508V34.127H116.667V28.9683Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 34.127H111.508V39.2857H116.667V34.127Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 39.2858H111.508V44.4445H116.667V39.2858Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 54.762H111.508V59.9207H116.667V54.762Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 65.0795H111.508V70.2382H116.667V65.0795Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 75.397H111.508V80.5557H116.667V75.397Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.0248a7c649d05b55a0eae99ed242563e.svg";
export { ForwardRef as ReactComponent };